import { useMutation, useQueryClient } from '@tanstack/react-query';
import { deleteProject } from '../../api/apiProjects';
import toast from 'react-hot-toast';

export const useDeleteProject = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: deleteProject,
        onSuccess: (data) => {
            queryClient.invalidateQueries({ queryKey: ['projects'] });
            toast.success(data.message || 'Project deleted successfully');
        },
        onError: (error) => {
            const errorMessage = error.response?.data?.message || 'Failed to delete project';
            toast.error(errorMessage);
        },
    });
};